import { t } from "../../i18n";
import type { ReactNode } from "react";
import type { ProjectSummary } from "../../storage";
import { Button } from "../../ui/Button";
import { useCadForm } from "../../ui/formContext";
import { BulkBar, SelectAllBox, useSelection } from "./selection";

/** Proje kütüğü: seçim · ad · duvar sayısı · güncelleme; satır başı eylemler, seçilince toplu silme. CAD bağlamında CadTable görünümü (README §2.4). */
export function RecentProjects({ items, onOpen, onDelete, extra, deleteHint }: { items: ProjectSummary[]; onOpen: (id: string) => void; onDelete: (ids: string[]) => void; extra?: (id: string) => ReactNode; /** silme onayına eklenen not (ör. "30 gün içinde geri alınabilir") */ deleteHint?: string }): JSX.Element {
  const cad = useCadForm();
  const sel = useSelection(items.map((p) => p.id));
  const del = (ids: string[], what: string): void => { if (window.confirm(`${what} ${t("silinsin mi?")}${deleteHint ? `\n${deleteHint}` : ""}`)) onDelete(ids); };
  if (items.length === 0) return <p className={cad ? "m-0 p-2 text-cad-ink3" : "text-sm text-stone border border-dashed border-rule rounded px-4 py-6"}>{t("Henüz kayıtlı proje yok.")} {t("Yeni proje ile başlayın; taslak otomatik kaydedilir.")}</p>;
  const th = cad ? "px-2 py-0.5 font-semibold text-left" : "py-2 font-medium";
  const td = cad ? "px-2 py-[3px]" : "py-2";
  return (
    <>
    <BulkBar s={sel} cad={cad}>
      <Button variant="danger" className={cad ? "!h-5" : "!py-1"} onClick={() => del(sel.selected, `${sel.selected.length} ${t("proje")}`)}>{t("Seçilenleri sil")}</Button>
    </BulkBar>
    <table className={cad ? "w-full text-[11px] border-collapse" : "w-full text-sm border-t border-ink"}>
      <thead><tr className={cad ? "bg-cad-head text-cad-ink2" : "text-left text-xs text-stone"}><th className={`${th} w-5`}><SelectAllBox s={sel} /></th><th className={th}>{t("Proje")}</th><th className={`${th} num`}>{t("Duvar")}</th><th className={th}>{t("Güncelleme")}</th><th className={th} /></tr></thead>
      <tbody>
        {items.map((p) => (
          <tr key={p.id} className={cad ? "border-b border-cad-soft2" : "border-t border-rule"}>
            <td className={td}><input type="checkbox" className="align-middle" checked={sel.has(p.id)} onChange={() => sel.toggle(p.id)} aria-label={`${p.name} ${t("projesini seç")}`} /></td>
            <td className={`${td} font-medium ${cad ? "text-cad-accent" : "text-ink"}`}><button type="button" className="hover:underline cursor-pointer text-left" onClick={() => onOpen(p.id)}>{p.name}</button></td>
            <td className={`${td} num ${cad ? "font-mono" : "text-ink/80"}`}>{p.wallCount}</td>
            <td className={`${td} num ${cad ? "font-mono" : "text-ink/80"}`}>{new Date(p.updatedAt).toLocaleString("tr-TR", { dateStyle: "medium", timeStyle: "short" })}</td>
            <td className={`${cad ? "px-2 py-px" : "py-1"} text-right whitespace-nowrap`}>
              {extra?.(p.id)}
              <Button variant="ghost" className={cad ? "!h-5" : "!py-1"} onClick={() => onOpen(p.id)} aria-label={`${p.name} projesini aç`}>{t("Aç")}</Button>
              <Button variant="danger" className={cad ? "!h-5 ml-1" : "!py-1"} onClick={() => del([p.id], `"${p.name}"`)} aria-label={`${p.name} projesini sil`}>{t("Sil")}</Button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
    </>
  );
}
